var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-card-title", { staticClass: "headline" }, [_vm._v("Guidelines")]),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "py-0" },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.itemsForAutoComplete,
                  box: "",
                  chips: "",
                  label: "Select Guideline",
                  "item-text": "GuideineName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function (data) {
                      return [
                        _c(
                          "v-list-tile-content",
                          [
                            _c("v-list-tile-title", {
                              domProps: {
                                innerHTML: _vm._s(data.item.GuidelineName),
                              },
                            }),
                            _vm._v(" "),
                            _c("v-list-tile-sub-title", {
                              domProps: {
                                innerHTML: _vm._s(data.item.GuidelineLongName),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item",
                    fn: function (data) {
                      return [
                        typeof data.item !== "object"
                          ? [
                              _c("v-list-tile-content", {
                                domProps: { textContent: _vm._s(data.item) },
                              }),
                            ]
                          : [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        data.item.GuidelineName
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        data.item.GuidelineLongName
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-xs-center caption pb-4 pt-3" },
        [
          _vm.items.length > 0
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.items.length) +
                    " " +
                    _vm._s(_vm.items.length > 1 ? "guidelines" : "guideline") +
                    " available\n    "
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }